import { CollectionViewer, DataSource, SelectionChange } from "@angular/cdk/collections";
import { SchemaTree } from "./SchemaTree";
import { BehaviorSubject, map, merge, Observable } from "rxjs";
import { MatTree } from "@angular/material/tree";
import { BeNeo4jService } from "../services/be-neo4j.service";
import { ISchemaTree } from "../interfaces/SchemaTree";
import { createSchemaTreeRecursive } from "../utils/utils";
import { ChangeDetectorRef } from "@angular/core";

export class TreeDynamicDataSource implements DataSource<SchemaTree> {
    dataChange = new BehaviorSubject<SchemaTree[]>([]);
    expandedUUIDs!: Set<string|undefined>;
  
    get data(): SchemaTree[] {
        return this.dataChange.value;
    }
    set data(value: SchemaTree[]) {

        this.expandedUUIDs = new Set<string|undefined>(
          this._treeControl._getExpansionModel().selected.map(node => node.UUID)
        );
        this._treeControl.dataSource = value;
        this.dataChange.next(value);

        this.expandMatching(value);
    }

    constructor(
        private _treeControl: MatTree<SchemaTree>,
        private beNeo4jService: BeNeo4jService
    ) { }

    expandMatching = (nodes: SchemaTree[]) => {
      for (const node of nodes) {
        if (this.expandedUUIDs.has(node.UUID) && node.has_children) {
          this._treeControl.expand(node);
        }
        if (node.children?.length) {
          this.expandMatching(node.children);
        }
      }
    };
  
    connect(collectionViewer: CollectionViewer): Observable<SchemaTree[]> {
      this._treeControl._getExpansionModel().changed.subscribe(change => {
        if (
          (change as SelectionChange<SchemaTree>).added ||
          (change as SelectionChange<SchemaTree>).removed
        ) {
          this.handleTreeControl(change as SelectionChange<SchemaTree>);
        }
      });
  
      return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
    }
  
    disconnect(collectionViewer: CollectionViewer): void {}
  
    /** Handle expand/collapse behaviors */
    handleTreeControl(change: SelectionChange<SchemaTree>) {
      if (change.added) {
        change.added.forEach(node => this.toggleNode(node, true));
      }
    }
  
    /**
     * Toggle the node, remove from display list
     */
    toggleNode(node: SchemaTree, expand: boolean) {
        if (expand) {
            if(node.children.length) return;
            node.isLoading.set(true);
            this.beNeo4jService.schemaTree(node.UUID, node.hierarchy).subscribe({
                next: (res: any) => {
                    let tree = (res as any).result[0].children.map((schema: ISchemaTree) => {
                        if(!schema.hierarchy) schema.hierarchy = (res as any).result[0].hierarchy;
                        return createSchemaTreeRecursive(schema)
                    });
                    node.children = tree;
                    this.dataChange.next(this.data);
                    node.isLoading.set(false);
                    this._treeControl.collapse(node);
                    setTimeout(()=>{
                      this._treeControl.expand(node);
                    },0)
                },
                error: (error) => {
                    node.isLoading.set(false);
                }
            });
        }
    }
  }